(() => {
  const initialise = (root) => {
    if (root.dataset.libraryReady) return;
    root.dataset.libraryReady = 'true';
    const input = root.querySelector('[data-library-search]');
    if (!input) return;
    const cards = [...root.querySelectorAll('[data-library-card]')];
    const groups = [...root.querySelectorAll('[data-library-group]')];
    const buttons = [...root.querySelectorAll('[data-library-filter]')];
    const count = root.querySelector('[data-library-count]');
    const clear = root.querySelector('[data-library-clear]');
    let category = 'all';
    const normalise = (text) => text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/['’‘]/g, '').toLowerCase().trim();
    const searchIndex = cards.map((card) => normalise(card.dataset.search));
    const filter = () => {
      const terms = normalise(input.value).split(/\s+/).filter(Boolean);
      let shown = 0;
      cards.forEach((card, index) => {
        const match = (category === 'all' || card.dataset.category === category) && terms.every((term) => searchIndex[index].includes(term));
        card.hidden = !match;
        if (match) shown += 1;
      });
      groups.forEach((group) => {
        const visible = [...group.querySelectorAll('[data-library-card]')].filter((card) => !card.hidden).length;
        group.hidden = visible === 0;
        group.querySelector('header > span').textContent = `${visible} ${visible === 1 ? 'entry' : 'entries'}`;
      });
      buttons.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.libraryFilter === category)));
      count.textContent = `${shown} ${shown === 1 ? 'entry' : 'entries'}${terms.length ? ' found' : ' to explore'}`;
      root.querySelector('[data-library-empty]').hidden = shown !== 0;
      clear.hidden = input.value.length === 0;
    };
    buttons.forEach((button) => button.addEventListener('click', () => { category = button.dataset.libraryFilter; filter(); }));
    input.addEventListener('input', filter);
    clear.addEventListener('click', () => { input.value = ''; filter(); input.focus(); });
    input.addEventListener('keydown', (event) => { if (event.key === 'Escape') { input.value = ''; filter(); } });
    root.querySelector('[data-library-reset]').addEventListener('click', () => { category = 'all'; input.value = ''; filter(); input.focus(); });
    root.querySelectorAll('[data-library-controls]').forEach((control) => { control.hidden = false; });
  };
  const scan = (scope = document) => scope.querySelectorAll('[data-eg-library]').forEach(initialise);
  scan();
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
})();
